// Side-effect module: imported right after the polyfills in index.tsx so the saved login is gone
// before the Parse SDK, SessionProvider or any service module can read it.
import { clearSavedLoginOnGuestJoin } from './utils/guestRouteSession'

clearSavedLoginOnGuestJoin()
